export default function logToConsole(message, backgroundColor = '#054597', color = 'white') {
  console.log(`%c${message}`, `background: ${backgroundColor}; color: ${color}`);

  if (process.env.NODE_ENV === 'development') {
    console.log(`%c dev mode `, `background: ${backgroundColor}; color: ${color}`);
  }
}
